import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { StepTemplateJSONAModel } from "interfaces/jsona-models/StepTemplateJSONAModel";

export class StepTemplateSelector extends BaseApiSelector<StepTemplateJSONAModel> {
  constructor() {
    super(ResourceType.StepTemplate);
  }
}
